import { SearchMigrationAdapter } from 'stores/adapters/bex-api/migration-adapters';

import { HotelResultsViewModel } from 'models';

import { OperationResult } from '__generated__/api/api-operations';
import { PropertySearch } from '__generated__/api';

export const adaptResultsSummary: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertySearch.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;

  if (!data.propertySearch) {
    return bffResults;
  }

  const { summary } = data.propertySearch;

  const loyaltyInfo = summary && summary.loyaltyInfo;

  return {
    ...bffResults,
    summaryMessages: summary && summary.resultsSummary,
    resultsHeading: summary && summary.resultsHeading,
    loyaltyMessagingModel: loyaltyInfo && {
      loyaltyPointsMessage: loyaltyInfo.saveWithPointsMessage,
      swpActionMessage: loyaltyInfo.saveWithPointsActionMessage
    }
  };
};
